import { SVGProps, Ref, forwardRef } from 'react';

export const GiftFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.324 1.024q.383.306.674.76.291-.454.674-.76c.84-.672 1.99-.742 2.783.051.794.794.724 1.944.052 2.784a3 3 0 0 1-.12.141h2.946C15.792 4 16 4.208 16 5.665s-.208 1.665-1.667 1.665H8.7V5H7.3v2.33H1.667C.208 7.33 0 7.122 0 5.665S.208 4 1.667 4H4.61a3 3 0 0 1-.12-.141c-.673-.84-.742-1.99.05-2.784.794-.793 1.945-.723 2.784-.051M5.531 2.065c.194-.194.524-.264.919.052.321.257.667.786.796 1.663-.877-.128-1.407-.475-1.664-.796-.315-.394-.245-.725-.051-.919m4.015.052c.395-.316.725-.246.92-.052.193.194.263.525-.052.92-.257.32-.787.667-1.664.795.129-.877.475-1.406.796-1.663"
                    fill="currentColor"
                />
                <path
                    d="M7.3 8.73H1.667q-.165.001-.334-.004v2.106h.002c.05 3.491 1.297 4.663 4.89 4.663H7.3z"
                    fill="currentColor"
                />
                <path
                    d="M8.7 15.495h1.082c3.593 0 4.84-1.171 4.89-4.663h.002V8.726q-.173.004-.34.004H8.7z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
GiftFilledSize16Glyph.displayName = 'GiftFilledSize16Glyph';
